<template>
  <div style="width: 100%">
    <loading :loading="loading"></loading>

    <button-with-image
      class="horizontal-center"
      :text="buttonText"
      :attach-image-des-src="uploadOkycImageSrc"
      :enabled-btn-style="uploadOkycButtonStyle"
      :enabled-text-style="{color: 'black'}"
      @onButtonClicked="onContinueClicked"
      :image-src="uploadOkycImageSrc"
      :disabled="okycCompleted"
    ></button-with-image>

  </div>
</template>
<script>

import dataSource from "@/data/DataSource";
import Loading from "@/components/layout/Loading";
import ButtonWithImage from "../layout/ButtonWithImage";
import { ImageResourcesUtil } from '../../utils/ImageResourcesUtil';
import EzUtils from '../../utils/EzUtils';
import { environment } from '../../environments/environment';
import { MessageConstants } from '../../utils/MessageConstantUtil';
import ActivityNavigator, { Activities } from '../../utils/ActivityNavigator';
import AlertService from '../core/alert/AlertService';
import DataSource from '../../data/DataSource';

const DIGIO = "DIGIO";

export default {
  name: "OkycItem",
  components: { Loading, ButtonWithImage },

  props: {
    buttonText : {
      type : String,
      required : false,
      default: "Digital KYC"
    },
    okycDataConfig: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data: () => ({
    title: "Okyc",
    perfiosLink: "",
    loading: false,
    networkError: {},
    errorAlertEvent: false,
    showDigioScriptRefresh: false,
    okycCompleted: false,
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onContinueClicked(){
      this.doOfflineKyc(this.okycDataConfig['vendorReferenceId'],this.okycDataConfig['mobileNo']);
    },

    loadDigioScript() {
      this.showDigioScriptRefresh = false;
      this.loading = true;
      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", environment.digiov9ScriptUrl);
      recaptchaScript.setAttribute("type", "text/javascript");
      document.head.appendChild(recaptchaScript);
      recaptchaScript.onload = () => {
        this.loading = false;
      };
      recaptchaScript.onerror = () => {
        outerContext.loading = false;
        outerContext.showDigioScriptRefresh = true;
      };
    },

    doOfflineKyc(requestId, mobileOrEmail) {
      const self = this;
      
      if(DIGIO === this.okycDataConfig.vendor){
        const digioConfig = {
          environment: environment.digioEnvironment,
          callback: function (response) {
            if (response.hasOwnProperty("error_code")) {
              self.onFailure();
            } else {
              self.onSuccess(response);
            }
          },
          logo: "",
          theme: {
            primaryColor: "#AB3498",
            secondaryColor: "#000000"
          },
          is_iframe: false
        };
        // eslint-disable-next-line no-undef
        const digio = new Digio(digioConfig);
        digio.init();
        digio.submit(requestId, mobileOrEmail);
      }
    },

    onSuccess(response) {
      if(response){
          this.loading = true;
          response['success'] = true;
          DataSource.processKycVendorCallback(
            this.okycDataConfig.vendor,
            response
          )
          .then(res => {
            if (!res.errorOccurred) {
              this.$emit('okycResponse',response);
              this.okycCompleted = true;
              this.loading = false;
            }else{
              this.onFailure();
            }
          });
        
      }else{
        this.onFailure();
      }

    },

    onFailure() {
      this.$emit('okycResponse',{success : false});
      this.loading = false;
      AlertService.showToast(MessageConstants.DOCUMENT_SIGNING_FAILED_MESSAGE);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

  },

  created: function () {
    if(DIGIO === this.okycDataConfig.vendor){
      this.loadDigioScript();
    } 
  },

  computed: {

    uploadOkycImageSrc() {
      return !this.okycCompleted ? 
        ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD) 
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN);
    },

    uploadOkycButtonStyle() {
      return {
        "background-color": "#fff",
        "border-color": "#96BFD2",
        "border-width": "1px",
        "border-style": "solid"
      };
    }
    
  }
}

</script>

<style scoped src="../../assets/style/base.css"></style>


